// src/components/Apm/ItemInv/ItemsInv.js

import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useMediaQuery, useTheme } from '@mui/material';

import { getItems } from '../../../redux/slices/itemForItemInvSlice';
import { columnsItemInvInvs } from '../Tables/Columns/columnsItemInvInvs';
import TableSimple from '../Tables/TableSimple';

const MOBILE_COLUMN_IDS = new Set(['description', 'code', 'vat']);

const ItemsInv = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const theme = useTheme();

  const smMediaDown = useMediaQuery(theme.breakpoints.down('sm'));

  const { itemsForItemInv = [], statusItemsForItemInv = null } = useSelector(
    (state) => state.itemForItemInvSlice ?? {}
  );

  useEffect(() => {
    if (itemsForItemInv.length === 0 && statusItemsForItemInv === null) {
      dispatch(getItems());
    }
  }, [dispatch, itemsForItemInv.length, statusItemsForItemInv]);

  const updatedColumns = useMemo(() => {
    const columns = columnsItemInvInvs();

    if (!smMediaDown) {
      return columns;
    }

    return columns.filter((column) => MOBILE_COLUMN_IDS.has(column.id));
  }, [smMediaDown]);

  return (
    <TableSimple
      resource="items-for-item-inv"
      columns={updatedColumns}
      popupTitle={t('popup.title.invoice_item')}
      data={itemsForItemInv}
      addButtonText={t('button.add_invoice_item')}
    />
  );
};

export default ItemsInv;
